import React, { useState } from "react";
import { GeoJSON } from "react-leaflet";
import { appText } from "../../texts";

const { controlsText } = appText;

const GeoJsonControls = ({
  pointData,
  pointData1,
  pointData2,
  pointToLayer,
  pointToLayer2,
  pointToLayer3,
  onEachFeature,
}) => {
  const getCssVariable = (variableName) =>
    getComputedStyle(document.documentElement)
      .getPropertyValue(variableName)
      .trim();

  const layers = [
    {
      key: "insurance",
      data: pointData,
      pointToLayer: pointToLayer,
      label: controlsText.insuranceText,
      color: getCssVariable("--primary-color"),
    },
    {
      key: "sam",
      data: pointData1,
      pointToLayer: pointToLayer2,
      label: controlsText.samText,
      color: getCssVariable("--secondary-color"),
    },
    {
      key: "station",
      data: pointData2,
      pointToLayer: pointToLayer3,
      label: controlsText.stationText,
      color: getCssVariable("--tertiary-color"),
    },
  ];

  const [visibleLayers, setVisibleLayers] = useState(
    layers?.reduce((acc, layer) => ({ ...acc, [layer.key]: true }), {})
  );

  const toggleLayer = (key) => {
    setVisibleLayers((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div>
      {/* کنترل‌ها */}
      <div className='points absolute mb-2 px-3 top-3 right-3 flex flex-col py-3 rounded-lg bg-[#3e3a49a1] text-[#fff]'>
        {layers?.map(({ key, label, color }) => (
          <label key={key} className='font-[myFont] flex items-center'>
            <input
              type='checkbox'
              checked={visibleLayers[key]}
              onChange={() => toggleLayer(key)}
              className='ml-2'
            />
            {label}
            <span
              style={{
                width: "12px",
                height: "12px",
                backgroundColor: color,
                borderRadius: "50%",
                marginRight: "8px",
              }}
            ></span>
          </label>
        ))}
      </div>

      {layers?.map(({ key, data, pointToLayer }) =>
        visibleLayers[key] && data ? (
          <GeoJSON
            key={`${key}-${visibleLayers[key]}`}
            data={{
              ...data,
              features: data?.features?.map((feature) => ({
                ...feature,
                properties: {
                  ...feature.properties,
                  sourceFile: key,
                },
              })),
            }}
            pointToLayer={pointToLayer}
            onEachFeature={onEachFeature}
          />
        ) : null
      )}
    </div>
  );
};

export default GeoJsonControls;
